import React, { useMemo, useState } from 'react';
import { EditorialHeader } from './components/EditorialHeader';
import { HeroStory } from './components/HeroStory';
import { AwardsStrip } from './components/AwardsStrip';
import { FloorDistribution } from './components/FloorDistribution';
import { NeedsAttention } from './components/NeedsAttention';
import { OfficerRoster } from './components/OfficerRoster';
import { OfficerDrawer } from './components/OfficerDrawer';
import { Pacesetters } from './components/Pacesetters';
import { mockOfficers } from './data/mockOfficers';
import { processOfficer } from './lib/officerUtils';
export function App() {
  const [selectedDate, setSelectedDate] = useState('2026-05-09');
  const [selectedOfficer, setSelectedOfficer] = useState<string | null>(null);
  const processed = useMemo(() => mockOfficers.map(processOfficer), []);
  const teamAvg = useMemo(() => {
    const valid = processed.filter(o => o.loginMin > 0);
    const n = Math.max(valid.length, 1);
    return {
      borrowerMin: valid.reduce((s, o) => s + o.borrowerMin, 0) / n,
      availableMin: valid.reduce((s, o) => s + o.availableMin, 0) / n,
      wrapUpMin: valid.reduce((s, o) => s + o.wrapUpMin, 0) / n,
      offQueueMin: valid.reduce((s, o) => s + o.offQueueMin, 0) / n,
      focusPct: valid.reduce((s, o) => s + o.focusPct, 0) / n,
      leadsConverted: valid.reduce((s, o) => s + o.leadsConverted, 0) / n,
      submissions: valid.reduce((s, o) => s + o.submissions, 0) / n,
      productionScore: valid.reduce((s, o) => s + o.productionScore, 0) / n
    };
  }, [processed]);
  const selected = selectedOfficer != null ? processed.find(o => o.name === selectedOfficer) ?? null : null;
  return <div className="w-full min-h-screen bg-bone font-sans text-ink" data-id="element-0">
      <EditorialHeader selectedDate={selectedDate} onDateChange={setSelectedDate} officerCount={processed.filter(o => o.loginMin > 0).length} data-id="element-1" />

      <HeroStory officers={processed} data-id="element-2" />

      <AwardsStrip officers={processed} onSelect={setSelectedOfficer} data-id="element-3" />

      <FloorDistribution officers={processed} data-id="element-4" />

      <NeedsAttention officers={processed} onSelect={setSelectedOfficer} data-id="element-5" />

      <OfficerRoster officers={processed} onSelect={setSelectedOfficer} data-id="element-6" />

      <Pacesetters officers={processed} onSelect={setSelectedOfficer} data-id="element-7" />

      <footer className="border-t border-ink-10" data-id="element-8">
        <div className="w-full px-8 lg:px-12 xl:px-16 py-8 flex items-center justify-between text-xs uppercase tracking-[0.22em] text-primary/50 font-bold" data-id="element-9">
          <span data-id="element-10">The Floor · Daily Briefing</span>
          <span className="font-serif font-bold normal-case tracking-normal italic text-sm" data-id="element-11">
            Compiled from agent state telemetry — refreshed each morning.
          </span>
        </div>
      </footer>

      <OfficerDrawer officer={selected} teamAvg={teamAvg} onClose={() => setSelectedOfficer(null)} data-id="element-12" />
    </div>;
}